import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";
import { useSurveyLocalesStore } from "@stores/survey/surveyLocales";
import { resolveLocalizedTitle } from "@/composables/useCardData";

type FilterFlags = Record<string, Record<string, boolean>>;
type FilterableCard = { name?: string; specs?: { answers?: { title?: unknown }[] } };

export const usePopulationLabels = () => {
  const { availableCards } = storeToRefs(useResultsV2Store());
  const { analysisLocale } = storeToRefs(useSurveyLocalesStore());

  const cardByQuestionId = computed(() => {
    const questionIdToCard: Record<string, FilterableCard> = {};
    for (const card of availableCards.value) {
      for (const question of card.questions || []) {
        questionIdToCard[question.id] = card;
      }
    }
    return questionIdToCard;
  });

  const filterSummary = (filters?: FilterFlags) => {
    const lines = Object.entries(filters || {})
      .map(([questionId, codeFlags]) => [questionId, Object.keys(codeFlags).filter((code) => codeFlags[code])] as const)
      .filter(([, codes]) => codes.length)
      .map(([questionId, codes]) => {
        const card = cardByQuestionId.value[questionId];
        const labels = codes.map((code) => {
          const answer = card?.specs?.answers?.[parseInt(code, 10) - 1];
          return (answer && resolveLocalizedTitle(answer.title, analysisLocale.value?.token)) || code;
        });
        return `${card?.name || `Question ${questionId}`} : ${labels.join(", ")}`;
      });

    return lines.length ? lines.join("\n") : "All respondents";
  };

  return { filterSummary };
};
